<template>
  <section class="topic wrapper">
    <img
      class="wow bounceInUp topic__img"
      src="~assets/topic.png"
      srcset="~assets/topic.png 2x"
    >

    <div
      class="video-container"
      :class="{
        playing: playing
      }"
    >
      <video
        ref="player"
        class="poster"
        webkit-playsinline="true"
        playsinline="true"
        x5-video-player-type="h5-page"
        x5-video-player-fullscreen="true"
        t7-video-player-type="inline"
        x-webkit-airplay="true"
        poster="~assets/poster.png"
        preload="true"
        src="//jin10south.oss-cn-hangzhou.aliyuncs.com/Act-ss-mp4-hd/4acba44bd83c4137a457435f5e293363/TTPS%E7%89%88%E5%A4%B4%E8%A7%86%E9%A2%91-05.mp4"
        :style="videoStyle"
        @click="onPause"
      />

      <i
        class="player"
        @click.stop="onPlay"
      />
    </div>
    {{ scrollTop }}
    <div
      v-if="diff !== 0"
      class="countdown-wrap"
      :class="{
        done: diff === 0
      }"
    >
      <div class="countdown">
        <div class="countdown-item">
          <span>{{ hour }}</span>
        </div>
        <div class="countdown-gap" />
        <div class="countdown-item">
          <span>{{ minute }}</span>
        </div>
        <div class="countdown-gap" />
        <div class="countdown-item">
          <span>{{ seconds }}</span>
        </div>
      </div>

      <button @click="onDialogChange(true)">
        预约咨询
      </button>
    </div>

    <div
      v-else
      class="btn-container"
    >
      <button
        class=""
        @click="onClick"
      >
        <i class="a-arrow left" />
        <i class="a-arrow left" />
        <strong>预约体验TTPS课程</strong>
        <i class="a-arrow right" />
        <i class="a-arrow right" />
      </button>
      <!-- <span>「100%免费 不过福利通道随时关闭哦」</span> -->
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import { device } from '@/utils';

const foramt = (s) => (s > 9 ? s : `0${s}`);

export default {
  name: 'Topic',
  components: {},
  props: {
    scrollTop: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isDone: false,
      diff: 261,
      duration: 261,
      playing: false,
    };
  },
  computed: {
    ...mapState(['contactVisible']),
    hour() {
      return foramt(Math.floor((this.diff / 60 / 60) % 24));
    },
    minute() {
      return foramt(Math.floor((this.diff / 60) % 60));
    },
    seconds() {
      return foramt(Math.floor(this.diff % 60));
    },
    isUc() {
      return navigator.userAgent.indexOf('UCBrowser') > -1 || navigator.userAgent.indexOf('HeyTapBrowser') > -1;
    },
    videoStyle() {
      // uc浏览器视频层级兼容
      if ((this.isUc || device.isDingTalk) && this.contactVisible) {
        return {
          width: '0px',
          height: '0px',
          overflow: 'hidden',
        };
      }
      return {};
    },
  },
  watch: {
    scrollTop() {
      if (this.scrollTop > this.offsetTop && this.playing) {
        this.autoPlay = true;
        this.playing = false;
        this.$refs.player.pause();
      } else if (this.scrollTop <= this.offsetTop && this.autoPlay) {
        this.onPlay();
      }
    },
  },
  mounted() {
    this.offsetTop = document.querySelector('.countdown-wrap').offsetTop;

    this.$refs.player.ontimeupdate = () => {
      this.playing = true;
    };

    this.$refs.player.onpause = () => {
      clearInterval(this.timer);
      this.playing = false;
    };

    this.$refs.player.onplaying = () => {
      if (this.$refs.player.currentTime > 10 && this.diff === 261) {
        setTimeout(() => {
          this.$refs.player.currentTime = 0;
        }, 500);
      }

      this.startCountdown();
      this.playing = true;
    };

    this.$refs.player.onended = () => {
      this.playing = false;
    };
  },
  methods: {
    onClick() {
      this.$emit('dialogVisible', true);
    },
    onPlay() {
      this.playing = true;
      this.$refs.player.play();
    },
    onPause() {
      this.autoPlay = false;
      if (this.playing) {
        this.playing = false;
        this.$refs.player.pause();
      } else {
        this.onPlay();
      }
    },
    startCountdown() {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        if (this.diff - 1 <= 0) {
          this.isDone = true;
          this.diff = 0;
          clearInterval(this.timer);
        } else {
          this.diff -= 1;
        }
      }, 1000);
    },
  },
};
</script>

<style scoped lang="scss">
$contentWidth: 1440px;
$deviceWidth: 1920px;

.topic {
  font-size: 0;
  overflow: hidden;
  background: url("~assets/bg.png") center top/contain no-repeat;
  @include hdpi() {
    background-image: url("~assets/bg@2x.png");
  }

  .topic__img {
    display: block;
    width: percentage(1000px / $deviceWidth);
    margin: percentage(140px / $deviceWidth) 0 0 percentage(240px / $deviceWidth);
    animation: fadeInUp .2s 1s ease-out both;
  }

  .topic__sub-img {
    display: block;
    width: percentage(536px / $deviceWidth);
    margin: percentage(67px / $deviceWidth) 0 0 percentage(240px / $deviceWidth);
    animation: fadeInUp .3s 1.2s ease-out both;

    &.mb {
      display: none;
    }
  }

  .video-container {
    position: relative;
    width: percentage(1152px / $deviceWidth);
    padding-top: percentage(640px / $deviceWidth);
    margin: percentage(56px / $deviceWidth) auto 0;
    overflow: hidden;
    animation: bounceIn .8s 1.2s both;
    background: url("~assets/poster.png") center/contain no-repeat;

    .poster {
      @include center();
      width: 100%;
    }

    .player {
      position: absolute;
      left: percentage(40px / 1152px);
      top: 50%;
      transform: translate(0, -50%);
      margin-top: percentage(180px / 1152px);
      width: percentage(120px / 1152px);
      padding-top: percentage(120px / 1152px);
      cursor: pointer;
      border-radius: 100%;
      background: url("~assets/player-m.png") center/contain no-repeat;
      @include hdpi() {
        background-image: url("~assets/player-m@2x.png");
      }

      &:hover {
        transition: all .3s;
        transform: translate(0, -50%) scale(1.08);
      }
    }

    &.playing {
      .player {
        display: none;
      }
    }
  }

  .countdown-wrap {
    position: relative;
    margin: percentage(65px / $deviceWidth) auto percentage(0px / $deviceWidth);
    padding: percentage(198px / $deviceWidth) 0 percentage(140px / $deviceWidth);
    background-color: #fff;
    text-align: center;
    background: #fff url("~assets/countdown-home.png") center/percentage(926px / $deviceWidth) auto no-repeat;
    @include hdpi() {
      background-image: url("~assets/countdown-home@2x.png");
    }
    animation: fadeInUp .2s 1.2s ease-out both;

    &::before {
      content: "";
      @include triangle(40px, 24px, #eef2f3, down);
      position: absolute;
      left: 50%;
      top: 0;
      transform: translate(-50%, 0);
    }

    button {
      font-size: 0;
      padding: 0;
      border: 0;
      background-color: none;
      &:active, &:focus {
        outline: none;
        border: 0;
      }
    }

    &.done {
      padding: percentage(175px / $deviceWidth) 0 percentage(160px / $deviceWidth);
      background: #fff url("~assets/success.png") center/percentage(926px / $deviceWidth) auto no-repeat;
      @include hdpi() {
        background-image: url("~assets/success@2x.png");
      }

      .countdown {
        display: none;
      }

      button {
        width: percentage(720px / $deviceWidth);
        padding-top: percentage(88px / $deviceWidth);
        background: #fff url("~assets/btn-success.png") center/contain no-repeat;
        @include hdpi() {
          background-image: url("~assets/btn-success@2x.png");
        }
        will-change: transform;
        animation: heartBeat 2.3s 1s infinite;
      }
    }

    .countdown {
      @include center();
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 auto;
      width: percentage(926px / $deviceWidth);

      &-item {
        position: relative;
        width: percentage(100px / 926px);
        padding-top: percentage(100px / 926px);
        background: url("~assets/num-bg.png") center/contain no-repeat;

        span {
          font-family: Din;
          font-size: 60px;
          font-weight: bold;
          color: #fff;
          @include center();
        }

        &::after {
          content: "";
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -1px);
          width: 96%;
          height: 2px;
          background-color: #135CD5;
        }
      }

      &-gap {
        width: percentage(94px / 926px);
        padding-top: percentage(94px / 926px);
        background: url("~assets/i.png") center/contain no-repeat;
        background-size: percentage(15px / 94px) auto;
      }
    }
  }

  .btn-container {
    width: percentage(736px / $deviceWidth);
    min-width: 620px;
    margin: percentage(56px / $deviceWidth) auto 0;
    animation: fadeInUp .3s 1.7s both;

    button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      padding: 0;
      font-size: 36px;
      line-height: 84px;
      color: #fff;
      font-weight: 600;
      border-radius: 4px;
      background-color: #305EE0;
      border: 0;
      animation: heartBeat 2.3s 3s infinite;

      strong {
        margin: 0 16px;
      }

      i {
        display: inline-block;
        flex-shrink: 0;
        width: 20px;
        height: 30px;
        vertical-align: middle;

        &.right {
          transform: rotate(180deg)
        }
      }
    }
    span {
      display: block;
      width: 100%;
      text-align: center;
      margin-top: percentage(24px / 804px);
      font-family: Source Han Sans CN;
      color: #3A4047;
      font-size: 24px;
      line-height: 56px;
      opacity: .8;
    }
  }

  @include mediaWidth(1440px) {
    .btn-container {
      span {
        font-size: 18px;
      }
    }
  }

  @include mediaWidth(1024px) {
    .btn-container {
      min-width: 480px;
      button {
        font-size: 24px;
        line-height: 64px;

        i {
          width: 14px
        }

      }
    }
  }

  @include mediaWidth(#{$mbWidth}) {

    background: url("~assets/bg-m.png") center top/100% 100% no-repeat;
    @include hdpi() {
      background-image: url("~assets/bg-m@2x.png");
    }

    .logo {
      width: percentage(151px / $mbWidth);
      margin-top: percentage(58px / $mbWidth);
      margin-left: percentage(24px / $mbWidth);
      padding-top: percentage(38px / $mbWidth);
      background: url("~assets/logo-m.png") center/contain no-repeat;
      @include hdpi() {
        background-image: url("~assets/logo-m@2x.png");
      }
    }

    .topic__img {
      width: percentage(684px / $mbWidth);
      margin: percentage(168px / $mbWidth) auto 0;
    }

    .topic__sub-img {
      display: none;
      width: percentage(608px/ $mbWidth);
      margin: percentage(70px / $mbWidth) auto 0;

      &.mb {
        display: block;
      }
    }

    .video-container {
      width: percentage(680px / $mbWidth);
      padding-top: percentage(383px / $mbWidth);
      margin: percentage(72px / $mbWidth) auto 0;

      .player {
        left: 16px;
        transform: translate(0, -50%);
        margin-top: 17%;
        background: url("~assets/player-m.png") center/contain no-repeat;
        @include hdpi() {
          background-image: url("~assets/player-m@2x.png");
        }
      }
    }

    .btn-container {
      min-width: auto;
      margin: percentage(35px / $mbWidth) auto percentage(70px / $mbWidth);
      width: percentage(562px / $mbWidth);

      button {
        background-color: #ffd36b;
        color: #44180f;

        i {
          width: 12px;
          background: url("data:image/svg+xml,%3Csvg width='20' height='30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4 4l11 11L4 26' stroke='%2344180f' stroke-width='5' fill='none' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E") center/contain no-repeat;
        }
      }

      span {
        margin-top: percentage(24px / 562px);
        color: #fff;
        font-size: 18px;
        line-height: 20px;
      }
    }

    .countdown-wrap {
      position: relative;
      padding: percentage(180px / $mbWidth) 0 percentage(180px / $mbWidth);
      margin: percentage(65px / $mbWidth) auto percentage(40px / $mbWidth);
      background: #fff url("~assets/countdown-m.png") center/percentage(678px / $mbWidth) auto no-repeat;
      @include hdpi() {
        background-image: url("~assets/countdown-m@2x.png");
      }

      &::before {
        content: "";
        @include triangle(36px, 20px, #1444cc, down);
        position: absolute;
        left: 50%;
        top: 0;
        transform: translate(-50%, 0);
      }

      &.done {
        padding: percentage(124px / $mbWidth) 0 percentage(128px / $mbWidth);
        background: #fff url("~assets/success-m.png") center/percentage(678px / $mbWidth) auto no-repeat;
        @include hdpi() {
          background-image: url("~assets/success-m@2x.png");
        }

        button {
          width: percentage(600px / $mbWidth);
          padding-top: percentage(74px / $mbWidth);
        }
      }

      .countdown {
        width: percentage(678px / $mbWidth);
        &-item {
          width: percentage(98px / 678px);
          padding-top: percentage(98px / 678px);
          span {
            font-size: 56px;
          }
        }
        &-gap {
          width: percentage(98px / 678px);
        }
      }
    }
  }

  @include mediaWidth(528px) {
    .btn-container {
      width: percentage(684px / $mbWidth);
      button {
        font-size: 16px;
        line-height: 48px;

        i {
          width: 10px;
          height: 16px;
        }
      }
      span {
        font-size: 14px;
      }
    }
    .countdown-wrap {
      .countdown {
        &-item {
          span {
            font-size: 36px;
          }
        }
      }
    }
  }
}
.IIV::-webkit-media-controls-play-button,
.IIV::-webkit-media-controls-start-playback-button {
    opacity: 0;
    pointer-events: none;
    width: 5px;
}
</style>
